/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20855Req {
  
  /** 模块id */
  moduleId?: string;
};



export interface API20855Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 20855 解绑用户模块

export interface IUsePostAPI20855Return {
  /** 解绑用户模块: 接口请求状态 */
  isAPI20855Loading: boolean;
  /** 解绑用户模块: 接口请求返回数据 */
  dataAPI20855: API20855Res;
  /**  解绑用户模块: 接口数据请求方法 */
  fetchAPI20855Data:  (inputs: API20855Req, config?: YWRequestConfig) => Promise<API20855Res>;
  /** 解绑用户模块: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20855 = ():IUsePostAPI20855Return => {
  let isMount = true;
  const [isAPI20855Loading, setIsAPI20855Loading] = useState(false);
  const [dataAPI20855, setDataAPI20855] = useState<API20855Res>({} as API20855Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/cloud/unlock/module`;

  const fetchAPI20855Data = async (inputs: API20855Req, config?: YWRequestConfig): Promise<API20855Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20855Req>) || {}) as API20855Req;
    
  
    if ( isMount ) {
      setIsAPI20855Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20855Res>(`${basePath}/ywwl-admin/desktop/cloud/unlock/module`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20855(res || {} as API20855Res);
        setIsAPI20855Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20855Loading(false);
      }
      return false as unknown as API20855Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20855Loading,
    dataAPI20855,
    fetchAPI20855Data,
    requestUrl,
  }
}

